export default __webpack_public_path__ + "images/business_d_account_logo.svg";